import { ReactComponent as CopyIcon } from 'app/assets/img/copy-icon.svg';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { IHolidayOrderDetail } from 'app/pages/HolidayCheckout/types';
import React, { memo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
interface Props {
  detailOrder: IHolidayOrderDetail;
}

export const PaymentSuccess = memo(({ detailOrder }: Props) => {
  const translations = useSelector(selectTranslations);
  const history = useHistory();
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<any>(null);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(detailOrder.orderCode || '');
      setCopied(true);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {}
  };
  const onClickDetail = () => {
    history.push(`/holiday/order-detail/${detailOrder.orderCode}`);
  };
  return (
    <Wrapper>
      <StatusIcon>✓</StatusIcon>
      <Title>{translations?.['b2b.callBack.success']}</Title>
      <SubTitle>{translations?.['b2b.txt.bookingCode']}</SubTitle>
      <CodeWrapper>
        <Code>{detailOrder.orderCode}</Code>
        <CopyButton onClick={handleCopy}>
          {copied ? <TickIcon>✓</TickIcon> : <CopyIconCss />}
        </CopyButton>
      </CodeWrapper>
      <Description>
        {translations?.['b2b.txt.checkEmailForFlightDetails']?.replace(
          '${email}',
          detailOrder.contact.email || '',
        )}
      </Description>
      <Actions>
        <SecondaryBtn onClick={onClickDetail}>
          {translations?.['b2b.txt.viewBookingCodeDetails']}
        </SecondaryBtn>
      </Actions>
    </Wrapper>
  );
});
const StatusIcon = styled.div`
  width: 32px;
  height: 32px;
  background: #00954d;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-weight: 700;
`;
const Title = styled.h2`
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 600;
`;
const SubTitle = styled.p`
  margin: 0 0 8px;
  color: #000;
  font-size: 14px;
`;
const CodeWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  background: var(--color-9);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 12px;
  height: 44px;
  flex-wrap: wrap;
`;
const Code = styled.div`
  color: #fff;
  font-weight: 600;
  padding: 10px 16px;
  font-size: 18px;
  letter-spacing: 1px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
`;
const CopyButton = styled.div`
  background: #fff1e3;
  border: none;
  padding: 0 12px;
  cursor: pointer;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

const SecondaryBtn = styled.button`
  background: #f2f2f2;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    opacity: 0.8;
  }
`;
const CopyIconCss = styled(CopyIcon)`
  height: 20px;
  filter: brightness(0) saturate(100%) invert(64%) sepia(63%) saturate(1246%)
    hue-rotate(345deg) brightness(99%) contrast(101%);
`;
const TickIcon = styled.div`
  height: 30px;
  width: 30px;
  color: var(--color-9);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
`;

const Wrapper = styled.div`
  width: 60%;
  margin: 0 auto;
  text-align: center;
  padding: 32px 16px;
  height: 100%;
  background: #fff;
  border-radius: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
`;
const Description = styled.p`
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 24px;

  a {
    color: #2563eb;
    text-decoration: none;
    font-weight: 500;
  }
`;
